function NewProjectReceipt() {
    return (
        <div>
            <form action="/" method="POST">

            <p className="content-block-text cover-page-centered cover-page-bu-title">
                Boston University Scientific Instrument Facility
            </p>

            <p className="content-block-text cover-page-centered work-order-sub-title">
                Work Order for the Physics Department Machine Shop
            </p>

            <div className="bu-redline-footer" style={{ width: '80%', marginTop: '1rem', backgroundColor: 'orange' }}></div>
            
            <p className="content-block-text cover-page-centered work-order-sub-title">
                Internal Request (University Jobs)
            </p>

            {/* <!-- department name & principle investigator & service request # --> */}
            <div className="cover-page-split-details-new-project">

                <p 
                className="content-block-text">
                Department Name:
                <br />
                <input
                    className="new-project-receipt-search-input"
                    id="new-project-receipt-search-input-department-name"
                    onClick={() => { console.log('department name search') }}
                    placeholder="&nbsp;&nbsp;search here..."
                />
                {/* <!-- auto-complete to user's department? --> */}
                </p>
                
                <p className="content-block-text">
                Principle Investigation:
                <br />
                <input
                    className="new-project-receipt-search-input"
                    id="new-project-receipt-search-input-principle-investigator"
                    onClick={() => { console.log('principle investigator search') }}
                    placeholder="&nbsp;&nbsp;enter or search here..."
                />
                </p>

                <p 
                className="content-block-text">
                Internal Service Request (ISR) #:
                <br />
                <input
                    className="new-project-receipt-search-input"
                    id="new-project-receipt-search-input-internal-service-request-no"
                    onClick={() => { console.log('internal service input') }}
                    placeholder="&nbsp;&nbsp;enter service request #..."
                />
                </p>
            </div>

            {/* <!-- contact person & information & source # --> */}
            <div className="cover-page-split-details-new-project">

                <p className="content-block-text">
                Contact Person:
                <br />
                <input
                    className="new-project-receipt-search-input"
                    id="new-project-receipt-search-input-contact-person-input"
                    onClick={() => { console.log('Contact Person search') }}
                    placeholder="&nbsp;&nbsp;enter or search here..."
                />
                </p>
                
                <p className="content-block-text">
                Contact Information:
                <br/>
                {/* <!-- phone number input --> */}
                <input
                    className="new-project-receipt-search-input"
                    id="new-project-receipt-search-input-contact-phone-no-input"
                    onClick={() => { console.log('Contact Person phone search') }}
                    placeholder="&nbsp;&nbsp;enter phone number..."
                />
                {/* <!-- email input --> */}
                <br/>
                <input
                    className="new-project-receipt-search-input"
                    id="new-project-receipt-search-input-contact-email-input"
                    onClick={() => { console.log('Contact Person email search') }}
                    placeholder="&nbsp;&nbsp;enter email..."
                />
                </p>

                <p className="content-block-text">
                Source # (Physics Only):
                <br />
                <input
                    className="new-project-receipt-search-input"
                    id="new-project-receipt-search-input-source-no"
                    onClick={() => { console.log('source no input') }}
                    placeholder="&nbsp;&nbsp;enter source # here..."
                />
                </p>
            </div>

                {/* <!-- All prices Estimates --> */}
            <p 
                className="content-block-text cover-page-centered work-order-sub-title"
                style={{ fontSize: '1.1rem' }}>
                <i>*All Prices Provided are Estimates Only*</i>
                {/* <!-- input box? I'm not sure if this is necessary --> */}
                <input
                    className="new-project-receipt-search-input"
                    id="new-project-receipt-search-input-estimate-input"
                    style={{ width: '10rem' }}
                    onClick={() => { console.log('estimate input') }}
                    placeholder="&nbsp;&nbsp;put the estimate here..."
                />
            </p>

            {/* <!-- submit internal button --> */}
            <div className="content-block-text cover-page-centered work-order-sub-title">
                <button 
                id="submit-button"
                className="submit-button"
                type="submit"
                value="Submit Internal Request"
                >
                Submit Internal Request
                </button>
            </div>
            </form>

            <div className="bu-redline-footer" style={{ width: '80%', marginTop: '1rem', backgroundColor: 'orange' }}></div>

            <form action="/" method="POST">
            {/* <!-- External Request --> */}
            <p className="content-block-text cover-page-centered work-order-sub-title">
                <i>External Request (Outside Job)</i>
            </p>

            {/* <!-- company name & contact person --> */}
            <div className="cover-page-split-details-new-project">

                <p 
                className="content-block-text">
                Company Name:
                <br/>
                <input
                    className="new-project-receipt-search-input"
                    id="new-project-receipt-search-input-company-name-input"
                    onClick={() => { console.log('company name input') }}
                    placeholder="&nbsp;&nbsp;enter or search here..."
                />
                </p>
                
                <p className="content-block-text">
                Contact Person:
                <br/>
                {/* <!-- name --> */}
                <input
                    className="new-project-receipt-search-input"
                    id="new-project-receipt-search-input-external-contact-person-input"
                    onClick={() => { console.log('Contact Person external input') }}
                    placeholder="&nbsp;&nbsp;enter name here..."
                />
                <br/>
                {/* <!-- phone --> */}
                <input
                    className="new-project-receipt-search-input"
                    id="new-project-receipt-search-input-external-contact-phone-no"
                    onClick={() => { console.log('Contact Person external no input') }}
                    placeholder="&nbsp;&nbsp;phone number..."
                />
                <br/>
                {/* <!-- email --> */}
                <input
                    className="new-project-receipt-search-input"
                    id="new-project-receipt-search-input-external-contact-email"
                    onClick={() => { console.log('Contact Person external email input') }}
                    placeholder="&nbsp;&nbsp;email..."
                />
                <br/>
                {/* <!-- fax --> */}
                <input
                    className="new-project-receipt-search-input"
                    id="new-project-receipt-search-input-external-contact-fax-no"
                    onClick={() => { console.log('Contact Person external fax no') }}
                    placeholder="&nbsp;&nbsp;fax..."
                />
                </p>

                <p 
                className="content-block-text">
                Purchase Order:
                <br/>
                <input
                    className="new-project-receipt-search-input"
                    id="new-project-receipt-search-input-purchase-order-input"
                    onClick={() => { console.log('purchase order input') }}
                    placeholder="&nbsp;&nbsp;enter here..."
                />
                </p>
            </div>

            {/* <!-- received name --> */}
            <div className="cover-page-split-details-new-project">

                <p className="content-block-text">
                Job Description:
                <br/>
                <input
                    className="new-project-receipt-search-input"
                    id="new-project-receipt-search-input-job-description-input"
                    onClick={() => { console.log('job description input') }}
                    placeholder="&nbsp;&nbsp;enter here..."
                />
                </p>

                <p 
                className="content-block-text">
                Received Name:
                <br/>
                <input
                    className="new-project-receipt-search-input"
                    id="new-project-receipt-search-input-received-name-input"
                    onClick={() => { console.log('received name input') }}
                    placeholder="&nbsp;&nbsp;enter or search here..."
                />
                </p>
                
                <p className="content-block-text">
                Date:
                <br/>
                {/* <!-- date picker --> */}
                <input
                    className="new-project-receipt-search-input"
                    id="new-project-receipt-search-input-received-name-input"
                    onClick={() => { console.log('received name input') }}
                    placeholder="&nbsp;&nbsp;enter or search here..."
                />
                </p>
            </div>

            {/* <!-- submit external button --> */}
            <div className="content-block-text cover-page-centered work-order-sub-title">
                <button 
                id="submit-button"
                className="submit-button"
                type="submit0"
                value="Submit External Request"
                >
                Submit External Request
                </button>
            </div>

            </form>
        </div>
    )
}

export default NewProjectReceipt;